import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Select, Form, Input, notification} from 'antd';

import {addStaffRole} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";

import permissions from "./permissions";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddStaffRoleForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.addStaffRole(values)
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Staff Role">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Permissions"
          >
            {getFieldDecorator('permissions', {
              rules: [],
            })(
              <Select mode="multiple" placeholder="Select permissions">
                {permissions.map(({value, text}) => <Option key={value} value={value}>{text}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Staff Role
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddStaffRoleForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addStaffRole: PropTypes.func.isRequired
};

const AddStaffRolePage = Form.create()(AddStaffRoleForm);

const mapStateToProps = state => ({
  loading: state.staffRole.addingStaffRole,
});

const mapDispatchToProps = dispatch => ({
  addStaffRole: bindActionCreators(addStaffRole, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AddStaffRolePage);



// WEBPACK FOOTER //
// ./src/StaffRole/AddStaffRolePage.js